// Import the Bootstrap framework.
// @link https://getbootstrap.com/docs/5.3/getting-started/vite/
import * as bootstrap from 'bootstrap';
import {Fancybox} from '@fancyapps/ui';

Fancybox.defaults.l10n = {
  CLOSE: 'Sluiten',
  NEXT: 'Volgende',
  PREV: 'Vorige',
  MODAL: 'Je kan deze modal sluiten met de ESC toets',
  ERROR: 'De gevraagde gegevens konden niet worden geladen. <br/> Probeer het later opnieuw.',
  IMAGE_ERROR: 'Afbeelding niet gevonden',
  TOGGLE_THUMBS: 'Miniaturen',
  TOGGLE_SLIDESHOW: 'Automatisch afspelen',
  TOGGLE_FULLSCREEN: 'Volledig scherm',
  DOWNLOAD: 'Downloaden',
  SHARE: 'Delen',
  ITERATEZOOM: 'Vergroten',
};

Fancybox.bind('[data-fancybox]', {});

document.documentElement.scrollLeft = 0;

function initInteractionObserver() {
  const classList = [
    'block-toptasks',
    'component-block',
    'frontend',
    'header-hero-container',
    'header-bottom',
    'hero',
    'figure',
    'section',
    'site-footer',
    'site-footer-top'
  ];

  const selectorString = classList.map(className => `.${className}`).join(', ');
  const myElements = document.querySelectorAll(selectorString);

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-viewport');
      }
    });
  }, {
    threshold: .1
  });

  myElements.forEach(element => {
    observer.observe(element);
  });
}

function initSearchForm() {
  var htmlClass = 'search-form-is-open';
  var expandedClass = 'is-open';
  var searchToggleSelector = '[data-search-toggle]';
  var searchToggleButtons = document.querySelectorAll(searchToggleSelector);
  var searchPopups = document.querySelectorAll('[data-search-popup]');
  var html = document.documentElement;
  let currentSearchPopup = null; // Track the current search popup

  /**
   * EventListener to close the search form on outside click.
   * @param {Event} e - The event object.
   */
  function outsideClickListener(e) {
    if (e.defaultPrevented) {
      return; // Do nothing if the event was already processed
    }

    if (currentSearchPopup) {
      var isClickInside = currentSearchPopup.contains(e.target);
      if (!isClickInside) {
        closeSearchPopup();
      }
    }
  }

  /**
   * EventListener to close the search form on Escape key.
   * @param {Event} e - The event object.
   */
  function keydownListener(e) {
    if (e.defaultPrevented) {
      return; // Do nothing if the event was already processed
    }

    switch (e.key) {
      case 'Escape':
      case 'Esc':
        closeSearchPopup();
        break;
      default:
        return; // Quit when this doesn't handle the key event.
    }
  }

  /**
   * Close the search form.
   */
  function closeSearchPopup() {
    html.classList.remove(htmlClass);

    searchPopups.forEach((searchPopup) => {
      searchPopup.classList.remove(expandedClass);
    });
    searchToggleButtons.forEach((searchToggleButton) => {
      searchToggleButton.setAttribute('aria-expanded', false);
    });

    document.removeEventListener('click', outsideClickListener);
    document.removeEventListener('keydown', keydownListener);
    currentSearchPopup = null; // Reset the current search popup
  }

  /**
   * Toggle the search form.
   * @param {HTMLElement} searchToggleButton - The button element that toggles the search form.
   */
  function toggleSearchForm(searchToggleButton) {
    const searchPopup = document.querySelector(
      `#${searchToggleButton.getAttribute('aria-controls')}`,
    );

    // Close all other search popups first
    searchPopups.forEach((popup) => {
      if (popup !== searchPopup) {
        popup.classList.remove(expandedClass);
      }
    });
    searchToggleButtons.forEach((button) => {
      if (button !== searchToggleButton) {
        button.setAttribute('aria-expanded', false);
      }
    });

    if (searchToggleButton.getAttribute('aria-expanded') === 'true') {
      closeSearchPopup();
    } else {
      html.classList.add(htmlClass);
      searchPopup.classList.add(expandedClass);
      searchToggleButton.setAttribute('aria-expanded', true);

      currentSearchPopup = searchPopup; // Track the open popup

      document.addEventListener('click', outsideClickListener);
      document.addEventListener('keydown', keydownListener, { once: true });

      // Stop propagation to prevent immediate closure
      searchPopup.addEventListener('click', (e) => {
        e.stopPropagation();
      });

      // Set focus on the search field.
      setTimeout(function() {
        var searchField = searchPopup.querySelector('input');
        if (searchField) {
          searchField.focus();
        }
      }, 300);
    }
  }

  searchToggleButtons.forEach((searchToggleButton) => {
    searchToggleButton.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent the event from bubbling up
      if (document.querySelector('.page-node-type-search')) {
        const searchField = document.querySelector('#searchBox');
        searchField.focus();
      } else {
        toggleSearchForm(searchToggleButton);
      }
    });
  });
}

// Replace broken images with SVG to prevent the breaking of the layout.
addEventListener('error', event => {
  if (event.target instanceof HTMLImageElement) {
    const img = event.target;
    if (img.src.match(/^data:/)) {
      return;
    }

    const width = parseInt(img.getAttribute('width') || 640);
    const height = parseInt(img.getAttribute('height') || 640);
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 ${width} ${height}">
      <rect x="0" y="0" width="${width}" height="${height}" fill="#fff0f0"/>
      <text x="${width / 2}" y="${height / 2 + 8}" text-anchor="middle" fill="#ff4040" style="font: 16px sans-serif">Broken image (${width} x ${height})</text>
    </svg>`;
    img.removeAttribute('srcset');
    img.setAttribute('data-original-src', img.src);
    img.src = `data:image/svg+xml;base64,${btoa(svg)}`;
    img.setAttribute('width', width);
    img.setAttribute('height', height);
  }
}, true);

// Hero scroll down button
document.addEventListener('DOMContentLoaded', function () {
  initInteractionObserver();
  initSearchForm();
});

/**
 * Add classes to the html element when the user scrolls.
 */
(function() {
  const htmlElement = document.documentElement;
  const pageTop = document.querySelector('.page-top');
  const scrolledClass = 'scrolled';
  const directionUpClass = 'sd-up';
  const directionDownClass = 'sd-down';

  let lastScrollTop = 0;

  // Detect when the .page-top leaves the viewport.
  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) {
      htmlElement.classList.add(scrolledClass);
    } else {
      htmlElement.classList.remove(scrolledClass);
    }
  }, { threshold: 0 });

  if (pageTop) {
    observer.observe(pageTop);
  }

  let timeout;
  document.addEventListener('scroll', () => {
    clearInterval(timeout);
    timeout = setTimeout(() => {
      const scrollTop = htmlElement.scrollTop;

      // Remove all classes when at the top of the page
      if (scrollTop === 0) {
        htmlElement.classList.remove(scrolledClass, directionUpClass, directionDownClass);
      } else if (scrollTop > lastScrollTop) {
        htmlElement.classList.add(directionDownClass);
        htmlElement.classList.remove(directionUpClass);
      } else {
        htmlElement.classList.add(directionUpClass);
        htmlElement.classList.remove(directionDownClass);
      }
      lastScrollTop = scrollTop;
    }, 50);
  });
})();
